//import waypoints from 'waypoints';
var waypoints = require("./jquery.waypoints.min.js");

class bhs_waypoints_animation {
  static init() {
    // if ($("body").hasClass("homepage")) {
    var $bhs_whatwedo_blocks_l = $(".bhs-whatwedo-blocks-l");
    var $bhs_whatwedo_blocks_r = $(".bhs-whatwedo-blocks-r");
    var $bhs_brand_blocks1 = $(".bhs-brand-blocks").eq(0);
    var $bhs_brand_blocks2 = $(".bhs-brand-blocks").eq(1);
    var $bhs_brand_blocks3 = $(".bhs-brand-blocks").eq(2);
    var $bhs_contact_blocks1 = $(".bhs-contact-blocks").eq(0);
    var $bhs_contact_blocks2 = $(".bhs-contact-blocks").eq(1);
    var $bhs_partners_container1 = $(".bhs-partners-container").eq(0);
    var $bhs_partners_container2 = $(".bhs-partners-container").eq(1);
    var $normal1 = $(".normal").eq(0);
    var $normal2 = $(".normal").eq(1);
    var $normal3 = $(".normal").eq(2);
    var $reverse1 = $(".reverse").eq(0);
    var $reverse2 = $(".reverse").eq(1);
    var $company =  $('.bhs-nav-sectionBtn.company');
    var $services =  $('.bhs-nav-sectionBtn.services');
    var $team =  $('.bhs-nav-sectionBtn.team');
    var $contacts =  $('.bhs-nav-sectionBtn.contact');
    var $introBlock = $('.bhs-intro-container');
    var $teamBlock = $('.bhs-team-container');
    var $servicesBlock = $('.bhs-aboutgrid-container');
    var $contactsBlock =  $('.bhs-contact-container');
    var offSet = "75%";
    var offSet1 = 100;
    var offSet2 = 200;

    // var waypoints = $introBlock.waypoint({
    //   handler: function(direction) {
    //     $('.bhs-nav-sectionBtn').removeClass("active");
    //     $company.addClass("active");
    //   },
    //   offset: offSet1
    // });

    // var waypoints = $teamBlock.waypoint({
    //   handler: function(direction) {
    //     $('.bhs-nav-sectionBtn').removeClass("active");
    //     $team.addClass("active");
    //   },
    //   offset: offSet1
    // });

    // var waypoints = $servicesBlock.waypoint({
    //   handler: function(direction) {
    //     $('.bhs-nav-sectionBtn').removeClass("active");
    //     $services.addClass("active");
    //   },
    //   offset: offSet1
    // });

    // var waypoints = $contactsBlock.waypoint({
    //   handler: function(direction) {
    //     $('.bhs-nav-sectionBtn').removeClass("active");
    //     $contacts.addClass("active");
    //   },
    //   offset: offSet1
    // });

    
    var waypoints = $normal1.waypoint({
      handler: function(direction) {
        $normal1.addClass("active");
      },
      offset: offSet
    });

    var waypoints = $reverse2.waypoint({
      handler: function(direction) {
        $reverse2.addClass("active");
      },
      offset: offSet
    });

    var waypoints = $normal2.waypoint({
      handler: function(direction) {
        $normal2.addClass("active");
      },
      offset: offSet
    });


    var waypoints = $normal3.waypoint({
      handler: function(direction) {
        $normal3.addClass("active");
      },
      offset: offSet
    });

    var waypoints = $reverse1.waypoint({
      handler: function(direction) {
        $reverse1.addClass("active");
      },
      offset: offSet
    });

    var waypoints = $bhs_whatwedo_blocks_l.waypoint({
      handler: function(direction) {
        $bhs_whatwedo_blocks_l.addClass("active");
      },
      offset: offSet
    });

    var waypoints = $bhs_whatwedo_blocks_l.waypoint({
      handler: function(direction) {
        $bhs_whatwedo_blocks_l.addClass("active");
      },
      offset: offSet
    });

    var waypoints = $bhs_whatwedo_blocks_r.waypoint({
      handler: function(direction) {
        $bhs_whatwedo_blocks_r.addClass("active");
      },
      offset: offSet
    });

    var waypoints = $bhs_brand_blocks1.waypoint({
      handler: function(direction) {
        $bhs_brand_blocks1.addClass("active");
      },
      offset: offSet
    });

    var waypoints = $bhs_brand_blocks2.waypoint({
      handler: function(direction) {
        $bhs_brand_blocks2.addClass("active");
      },
      offset: offSet
    });

    var waypoints = $bhs_brand_blocks3.waypoint({
      handler: function(direction) {
        $bhs_brand_blocks3.addClass("active");
      },
      offset: offSet
    });

    var waypoints = $bhs_contact_blocks1.waypoint({
      handler: function(direction) {
        $bhs_contact_blocks1.addClass("active");
      },
      offset: offSet
    });

    var waypoints = $bhs_contact_blocks2.waypoint({
      handler: function(direction) {
        $bhs_contact_blocks2.addClass("active");
      },
      offset: offSet
    });

    var waypoints = $bhs_partners_container1.waypoint({
      handler: function(direction) {
        $bhs_partners_container1.addClass("active");
      },
      offset: offSet
    });

    var waypoints = $bhs_partners_container2.waypoint({
      handler: function(direction) {
        $bhs_partners_container2.addClass("active");
      },
      offset: offSet
    });
    //  } else {
    //  }
  }
}

module.exports = bhs_waypoints_animation;
